/// <amd-module name="Wit/Settings/BoardsExternalIntegration/telemetry/GitHub" />
import { IVssPageContext } from "VSS/Platform/Context";
import { IVssComponentContext } from "VSS/Platform/Layout";
import { IVssTelemetryService } from "VSS/Platform/Telemetry";
import { IVssTraceService } from "VSS/Platform/Trace";
import { WITCustomerIntelligenceArea } from "Wit/Common/Constants/CustomerInteligence";

export const WITCIGitHubIntegrationFeature = "GitHubIntegration";

export namespace GitHubIntegrationCIActions {
    export const ADD_REPO_PANEL_OPEN = "ADD_REPO_PANEL_OPEN";
    export const ADMIN_OPEN = "ADMIN_OPEN";
    export const ADMIN_OPEN_NONPROJECTADMIN = "ADMIN_OPEN_NONPROJECTADMIN";
    export const ADMIN_NEW_CONNECTION_UNIFIEDINSTALL = "ADMIN_NEW_CONNECTION_UNIFIEDINSTALL";
    export const ADMIN_NEW_CONNECTION_PAT = "ADMIN_NEW_CONNECTION_PAT";
    export const ADMIN_NEW_CONNECTION_USING_GHE = "ADMIN_NEW_CONNECTION_USING_GHE";
    export const ADMIN_REMOVE_CONNECTION = "ADMIN_REMOVE_CONNECTION";
    export const ADMIN_ADD_REPOS = "ADMIN_ADD_REPOS";
    export const ADMIN_REMOVE_REPOS = "ADMIN_REMOVE_REPOS";
    export const ADMIN_NEW_CONNECTION_OAUTH_ENTERPRISE = "ADMIN_NEW_CONNECTION_OAUTH_ENTERPRISE";
    export const ADMIN_NEW_CONNECTION_PAT_ENTERPRISE = "ADMIN_NEW_CONNECTION_PAT_ENTERPRISE";
    export const ADMIN_NEW_CONNECTION_CREDENTIALS_ENTERPRISE = "ADMIN_NEW_CONNECTION_CREDENTIALS_ENTERPRISE";
    export const ADMIN_ADD_EXISTING_REPOS = "ADMIN_ADD_EXISTING_REPOS";
    export const ADMIN_REMOVE_EXISTING_REPOS = "ADMIN_REMOVE_EXISTING_REPOS";
    export const ADMIN_REMOVE_INACTIVE_CONNECTION = "ADMIN_REMOVE_INACTIVE_CONNECTION";
    export const FRE_CREATE_SAMPLE_WORK_ITEM = "FRE_CREATE_SAMPLE_WORK_ITEM";
    export const FRE_CREATE_LINK_GITHUB_PULL_REQUEST = "FRE_CREATE_LINK_GITHUB_PULL_REQUEST";
    export const FRE_SET_BOARD_BADGE_ANONYMOUS_ACCESS = "FRE_SET_BOARD_BADGE_ANONYMOUS_ACCESS";
    export const FRE_OPEN_WORKITEM = "FRE_OPEN_WORKITEM";
    export const FRE_PANEL_CLOSED = "FRE_PANEL_CLOSED";
    export const FRE_STATIC_PANEL_CLOSED = "FRE_STATIC_PANEL_CLOSED";
    export const FRE_PRECREATE_CONNECTION = "FRE_PRECREATE_CONNECTION";
    export const FRE_PRESELECT_REPO = "FRE_PRESELECT_REPO";
    export const ORG_PANEL_OPEN = "ORG_PANEL_OPEN";
    export const ADMIN_INSTALLATION_REDIRECTION = "ADMIN_INSTALLATION_REDIRECTION";
    export const UNIFIED_EXPERIENCE_ADD_REPO_AFTER_INSTALLATION = "UNIFIED_EXPERIENCE_ADD_REPO_AFTER_INSTALLATION";
}

export function publishGitHubIntegrationTelemetry(componentContext: IVssComponentContext, action: string, properties: { [key: string]: any } = {}) {
    publishGitHubIntegrationTelemetryWithPageContext(componentContext.pageContext, action, properties);
}

export function publishGitHubIntegrationTrace(componentContext: IVssComponentContext, message: string, properties: { [key: string]: any } = {}) {
    publishGitHubIntegrationTraceWithPageContext(componentContext.pageContext, message, properties);
}

export function publishGitHubIntegrationTraceWithPageContext(pageContext: IVssPageContext, message: string, properties: { [key: string]: any } = {}) {
    const traceService = pageContext.getService<IVssTraceService>("IVssTraceService");
    traceService.traceError(WITCustomerIntelligenceArea, WITCIGitHubIntegrationFeature, message, properties);
}

export function publishGitHubIntegrationTelemetryWithPageContext(
    pageContext: IVssPageContext,
    action: string,
    properties: { [key: string]: any } = {}
) {
    const telemetryService = pageContext.getService<IVssTelemetryService>("IVssTelemetryService");
    telemetryService.publishEvent(WITCustomerIntelligenceArea, WITCIGitHubIntegrationFeature, {
        action,
        ...properties
    });
}
